import { Component, ElementRef, Renderer2, inject } from '@angular/core';
import { WINDOW_TOKEN } from '../../../services/bootstrap.service';

@Component({
  selector: 'td-wb-min-height-panel',
  styleUrls: ['min-height-panel.component.scss'],
  template: '<ng-content />'
})
export class MinHeightPanelComponent {

  private minHeightSet: boolean;
  private readonly elementRef: ElementRef = inject(ElementRef);
  private readonly renderer: Renderer2 = inject(Renderer2);
  private readonly browserWindow: Window = inject(WINDOW_TOKEN);

  addTrigger(): void {
    this.resetMinHeight();
  }

  removeTrigger(): void {
    this.setMinHeight();
  }

  private setMinHeight(): void {
    if (!this.minHeightSet && this.documentHeight() > this.browserWindow.innerHeight) {
      const element: HTMLElement = this.elementRef.nativeElement;
      const height: number = element.getBoundingClientRect().height;
      this.renderer.setStyle(element, 'min-height',  `${height}px`);
      this.minHeightSet = true;
    }
  }

  private resetMinHeight(): void {
    this.renderer.removeStyle(this.elementRef.nativeElement, 'min-height');
    this.minHeightSet = false;
  }

  private documentHeight(): number {
    const doc: HTMLElement = this.browserWindow.document.documentElement;
    const body: HTMLElement = this.browserWindow.document.body;
    return Math.max(
      body.scrollHeight,
      doc.scrollHeight,
      body.offsetHeight,
      doc.offsetHeight,
      doc.clientHeight
    );
  }
}
